import { IconWrapper } from '../runtime';
export default IconWrapper('members-company-shape', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
      "fill": "#0A6CFF"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.75 6V8H12V9.5H8.75V11H13V12.5H3V11H4.5V8H6V11H7.25V6H8.75ZM9.61834 3L13 5.85L12 7L9.07294 4.5H6.92563L4 7L3 5.85L6.38166 3H9.61834Z",
      "fill": "white"
    }
  })]);
});